import React from 'react';
import { Button } from '@mui/material';
import { useAuth } from '../services/AuthContext';
import { useNavigate } from 'react-router-dom';

interface ProtectedDownloadButtonProps {
  pdfUrl: string;
  buttonText: string;
  icon?: string;
}

const ProtectedDownloadButton: React.FC<ProtectedDownloadButtonProps> = ({
  pdfUrl,
  buttonText,
  icon
}) => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  const handleDownload = (e: React.MouseEvent) => {
    if (!isAuthenticated) {
      e.preventDefault();
      login();
    }
  };

  return (
    <Button
      variant="contained"
      className="download-button"
      href={isAuthenticated ? pdfUrl : '#'}
      onClick={handleDownload}
      download
      style={{ marginTop: '10px' }}
    >
      {icon && <img src={icon} alt="Descargar" />}
      {buttonText}
    </Button>
  );
};

export default ProtectedDownloadButton; 